import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { StatusRequestModel } from 'src/app/models/status/status-request.model';
import { BuilderRequestAutoExportSettingsModel } from 'src/app/models/builder/builder-request-auto-export-settings.model';
import { BuilderValidationSummaryModel } from 'src/app/models/builder/builder-validation-summary.model';

/**
 * API client for the Status-Request API
 */
@Injectable({
    providedIn: 'root'
})
export class StatusRequestApiClient {

    private ControllerEndpoint: string = environment.apiUrl + "/fe-api/status-request/";


    constructor(private httpClient: HttpClient) { }

    /**
     * Get the Request for Status (if allowed)
     * @param requestGuid 
     */
    async Get(requestGuid: string): Promise<Observable<StatusRequestModel>> {
        return await this.httpClient.get<StatusRequestModel>(this.ControllerEndpoint + requestGuid);
    }
    
    /**
     *  Update the auto export data for the request.
     *  -HANDLES THE SUBSCRIBE
     */
    async SetAutoExport(model: BuilderRequestAutoExportSettingsModel): Promise<any> {
        return await this.httpClient.post<BuilderValidationSummaryModel>(this.ControllerEndpoint + "auto-export", model).subscribe();
    }

}
